var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaplex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_190)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.7094,
    y: 7.86218,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2184 41.8391C51.4754 42.2771 51.1581 42.8275 50.6484 42.8275H44.9135C44.6792 42.8275 44.4625 42.7039 44.344 42.5026L33.2156 23.5983C32.9577 23.1603 33.2751 22.6091 33.7851 22.6091H39.5521C39.7867 22.6091 40.0037 22.7331 40.122 22.9347L51.2184 41.8391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7751 36.7004C35.9072 36.9218 35.8972 37.1995 35.7497 37.4109L32.5586 41.9831C32.2835 42.3771 31.6906 42.3544 31.4469 41.9404L20.6495 23.5983C20.3917 23.1603 20.709 22.6091 21.2191 22.6091H26.9892C27.2221 22.6091 27.4378 22.7313 27.5567 22.9306L35.7751 36.7004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7698 41.6563C26.0308 42.0943 25.7137 42.6485 25.2021 42.6485H21.2454C20.8809 42.6485 20.5853 42.3544 20.5853 41.9916V35.3527C20.5853 34.6846 21.4707 34.4429 21.8131 35.0175L25.7698 41.6563Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_190",
    x: 0.209351,
    y: 0.162183,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_190",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_190"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5094,
    y: 22.5621,
    width: 30.8,
    height: 20.3,
    rx: 10.15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaplex);
export default __webpack_public_path__ + "static/media/metaplex.fab5f59c3cd194545d2940c86cafd46b.svg";
export { ForwardRef as ReactComponent };